// extracted by mini-css-extract-plugin
export default {"wrap":"new-version-notifier_wrap__Fl8KT","notification":"new-version-notifier_notification__8Nn+7","icon":"new-version-notifier_icon__2rC72"};